import {Person} from '../types/Person';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class PeopleService {
  public async getAllPeople(): Promise<Person[]> {
    return handleError(
      () => httpClient.get<Person[]>('/people'),
      'Error fetching people:',
      () => []
    );
  }

  public async getPerson(id: string): Promise<Person> {
    return handleError(
      () => httpClient.get<Person>(`/people/${id}`),
      'Error fetching person:'
    );
  }

  public async createPerson(person: Omit<Person, 'id'>): Promise<void> {
    const personWithId = {
      ...person,
      id: crypto.randomUUID()
    };
    return handleError(
      () => httpClient.post<void>('/people', personWithId),
      'Error creating person:'
    );
  }

  public async updatePerson(person: Person): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/people/${person.id}`, person),
      'Error updating person:'
    );
  }

  public async deletePerson(id: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/people/${id}`),
      'Error deleting person:'
    );
  }
}

const peopleService = new PeopleService();
export default peopleService;
